import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { loginWithGoogle } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        await loginWithGoogle(sid);
        window.history.replaceState({}, "", "/dashboard");
        toast.success("Login com Google concluído!");
        nav("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Falha ao autenticar com Google");
        nav("/login", { replace: true });
      }
    })();
  }, [loginWithGoogle, nav]);

  return <div className="min-h-screen grid place-items-center text-slate-500">Autenticando…</div>;
}
